module.exports = {
  urls: {
    app: 'https://app.hackedu.dev',
    control: 'https://control.hackedu.dev',
    controlK8s: 'https://api.sandbox-k8s.hackedu.dev',
    hacker: 'https://platform.hackedu.dev/hacker/v2',
    samy: 'https://samy.hackedu.dev',
    www: 'https://www.hackedu.dev',
    linter: 'https://platform.hackedu.dev/linter/v2',
    githubApp: 'https://github.com/apps/hackedu-test/installations/new?',
    slackApp: 'https://slack.com/oauth/v2/authorize?client_id=203999096960.1405424683013&scope=chat:write,chat:write.customize,groups:write,im:write,mpim:write,users:read,users:read.email&user_scope=',
    microsoftApp: 'https://login.microsoftonline.com/common/adminconsent?client_id=9a29e77c-154f-4dee-b957-a894a7d665bf&redirect_uri=https%3A%2F%2Fwww.hackedu.dev%2Fapp-integrations%2Fmicrosoft-teams-callback',
    rewards: 'https://rewards.k8s.hackedu.dev',
  },
  aws: {
    region: 'us-east-1',
    identityPoolId: 'us-east-1:46517db2-5331-4aa7-9354-3cbd9aad76b8',
  },
  cognito: {
    authData: {
      ClientId: 'i78kjordr8ijhnnhf92sm5p24',
      AppWebDomain: 'auth.hackedu.dev',
      TokenScopesArray: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
      RedirectUriSignIn: 'https://app.hackedu.dev/auth',
      RedirectUriSignOut: 'https://app.hackedu.dev',
      UserPoolId: 'us-east-1_SlBDp9xy2',
      AdvancedSecurityDataCollectionFlag: false,
    },
  },
  saml: {
    checkDomainAssociationUri: 'https://platform.hackedu.dev/auth/v2/domain',
  },
  segment: {
    key: 'FnZoB09pnPOAuGdsdyaNNu68prLpIsLN',
  },
  launchDarkly: {
    clientSideId: '61e1b06b0e7a8916040690d1'
  },
  sentry: {
    tracesSampleRate: 1.0
  }
}
